import CustomHeader from 'components/ReusableComponents/HeaderTitles'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import { useInternalAdmin } from 'hooks'
import { AnalyticsContextWrapper } from 'hooks/useAllHotels'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import { MonthlyRevenueCharts } from './MonthlyRevenueCharts'
import { MonthlyRevenueFilters } from './MonthlyRevenueFilters'
import styles from './MontlyRevenue.module.scss'
import { dataTypesToShow } from './utils/constants'
import { groupHotelsByCity } from './utils/hotelHelpers'
import useMonthlyRevenueData from './utils/useMonthlyRevenueData'

const MonthlyRevenue = () => {
  const [firstYear, setFirstYear] = useState()
  const [secondYear, setSecondYear] = useState()
  const [dataToShow, setDataToShow] = useState(dataTypesToShow.Consumed)
  const [groupToFilter, setGroupToFilter] = useState()
  const [stateToFilter, setStateToFilter] = useState('')
  const [cityToFilter, setCityToFilter] = useState('')
  const [showAllHotels, setShowAllHotels] = useState(false)
  const [showWholeGroup, setShowWholeGroup] = useState(false)
  const [parentChain, setParentChain] = useState()

  const isInternalAdmin = useInternalAdmin()

  const isDemoMode = useSelector(s => s.login.isDemoMode)

  const {
    isLoading,
    isFetching,
    isErred,
    errorText,
    response,
    groupHotelData,
    groupName,
    hotelGroups,
    availableCities,
    cumulativeData,
    minimumAvailableYear
  } = useMonthlyRevenueData({
    firstYear,
    secondYear,
    showWholeGroup,
    showAllHotels,
    parentChain,
    dataToShow,
    cityToFilter,
    stateToFilter,
    groupToFilter
  })

  function handleChangeState(state) {
    setStateToFilter(state)
    setCityToFilter('')
  }

  if (isLoading) {
    return <LoadingIndicator />
  }

  function handleChangeGroupFilter(value) {
    if (value === 'currentHotel') {
      setShowWholeGroup(false)
      setShowAllHotels(false)
      setGroupToFilter()
    }

    if (value === 'allHotels') {
      setShowWholeGroup(false)
      setShowAllHotels(true)
      setGroupToFilter()
    }

    if (value !== 'currentHotel' && value !== 'allHotels') {
      setGroupToFilter(value)
      setShowAllHotels(true)
      setShowWholeGroup(false)
    }
  }

  const groupedHotels = groupHotelData ? groupHotelsByCity(groupHotelData) : []

  return (
    <div className={styles.wrapper}>
      <CustomHeader title="Monthly Revenue" width={1080} />
      <MonthlyRevenueFilters
        dataToShow={dataToShow}
        setDataToShow={setDataToShow}
        isInternalAdmin={isInternalAdmin}
        hotelGroups={hotelGroups}
        isDemoMode={isDemoMode}
        handleChangeGroupFilter={handleChangeGroupFilter}
        showAllHotels={showAllHotels}
        showWholeGroup={showWholeGroup}
        parentChain={parentChain}
        setParentChain={setParentChain}
        stateToFilter={stateToFilter}
        handleChangeState={handleChangeState}
        availableCities={availableCities}
        cityToFilter={cityToFilter}
        setCityToFilter={setCityToFilter}
        firstYear={firstYear}
        secondYear={secondYear}
        minimumAvailableYear={minimumAvailableYear}
        setFirstYear={setFirstYear}
        setSecondYear={setSecondYear}
      />
      {isErred && (
        <div className={styles.noData}>
          <p>{errorText}</p>
        </div>
      )}
      {!isErred && (
        <MonthlyRevenueCharts
          isErred={isErred}
          errorText={errorText}
          cumulativeData={cumulativeData}
          response={response}
          groupHotelData={groupHotelData}
          groupName={groupName}
          isFetching={isFetching}
          groupedHotels={groupedHotels}
          isDemoMode={isDemoMode}
          dataToShow={dataToShow}
        />
      )}
    </div>
  )
}

const MonthlyRevenueWithContext = () => (
  <AnalyticsContextWrapper>
    <MonthlyRevenue />
  </AnalyticsContextWrapper>
)

export default MonthlyRevenueWithContext
